import { render, staticRenderFns } from "./ListSuplotsAreas.vue?vue&type=template&id=33993fea"
import script from "./ListSuplotsAreas.vue?vue&type=script&lang=js"
export * from "./ListSuplotsAreas.vue?vue&type=script&lang=js"
import style0 from "./ListSuplotsAreas.vue?vue&type=style&index=0&id=33993fea&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33993fea')) {
      api.createRecord('33993fea', component.options)
    } else {
      api.reload('33993fea', component.options)
    }
    module.hot.accept("./ListSuplotsAreas.vue?vue&type=template&id=33993fea", function () {
      api.rerender('33993fea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/flow/productiveAreas/detail/component/ListSuplotsAreas.vue"
export default component.exports